const prefix = '/v1/api/mynavi/mypage';
const mypage = '2';
const prefixCp2 = '/v1/api/mynavi/cp2';

export const endpoint = {
  authLogin: prefix + '/auth/login',
  authLogout: prefix + '/auth/logout',

  refreshToken: prefix + '/auth/reissue-token', // post with refreshToken

  passwordReissue: prefix + '/user/password/reissue', // パスワード再発行
  passwordSetting: prefix + '/user/password/setting', // パスワード設定
  passwordCheckKey: prefix + '/user/password/check-key', // ユニークキー有効チェック

  getCareerId: prefix + '/user/getCareerId', // 求職者ID取得

  userMenu: prefix + '/user/menu', // メニュー表示制御

  getMypageNews: prefix + '/trnmypagenews/select', // お知らせ情報取得
  getMypageNewsList: prefix + '/trnmypagenews/getList', // お知らせ情報一覧取得

  // E_**画面, N_**画面
  passwordEdit: prefix + '/user/changePassword', // パスワード 更新
  mailAddress: prefix + '/user/mailAddress', // メールアドレス 取得

  // TrnCareer `/mypage/trncareer/`
  getCareerInfo: prefix + '/trncareer/select',
  updateSettingFlag: prefix + '/trncareer/updateSetting',
  getCareerInfoForRecommend: prefix + '/trncareer/getRecommend',
  getCareerInfoForResume: prefix + '/trncareer/getResumeData',
  getCareerInfoForConditionSearch: prefix + '/trncareer/getConditionSearch',

  getShintyoku: prefix + '/trnshintyoku/select', // 進捗情報取得
  setShintyoku: prefix + '/trnshintyoku/update', // 進捗情報更新
  setPendingFlg: prefix + '/trnshintyoku/updatependingflag', // 気になる
  countCloseApplyProgress: prefix + '/trnshintyoku/countCloseApplyProgress', 

  updateRefusalShintyoku: prefix + '/trnshintyoku/updaterefusaldata', // 応募しない求人一覧
  updateApplyShintyoku: prefix + '/trnshintyoku/updateapplydata',
  updateApplyPublicMultiShintyoku: prefix + '/trnshintyoku/applymultiplefromsearch',
  updateApplyShintyokuFromSearch: prefix + '/trnshintyoku/applyfromsearch', // 応募しない求人一覧
  updateReApplyShintyoku: prefix + '/trnshintyoku/reapplyprogress',
  checkReApply: prefix + '/trnshintyoku/checkreapply',
  checkApply: prefix + '/trnshintyoku/checkapply',

  // ShintyokuSub
  upInsShintyokusub: prefix + '/trnshintyokusub/update',
  upInsBuklShintyokusub: prefix + '/trnshintyokusub/bulkupdate',

  writelogtrnoperationlog: prefix + '/trnoperationlogmypage/writelog', // 操作ログ登録
  countApplyList: prefix + '/trnshintyoku/countapplylist', // 応募管理
  getLocation: prefix + '/trnorderlocation/select', // 勤務地取得
  getLocationMt: prefix + '/trnorderlocation_mt/select',

  updateRecommend: prefix + '/trncareer/updateRecommend',
  updateResume: prefix + '/trncareer/updateResume',
  updateBasicInfo: prefix + '/trncareer/updateBasicInfo',
  selectZipCode: prefix + '/mstzipcode/select',
  getMstUserInfo: prefix + '/mstuser/info',

  getAdvisorHistory: prefix + '/trnsubmitadvisorhistory/select',
  getMstMypageVideoKnowHow: prefix + '/mstmypagevideoknowhow/select', // 転職活動ノウハウ動画
  fileDownload: prefix + '/file/download',
  submitAdvisorHistory: prefix + '/trnsubmitadvisorhistory/submit',
  getAdvertisement: prefix + '/advertisement/select',
  updateAdvertisementBrowsingFlag: prefix + '/advertisement/updateclientbrowsingflg',

  getOrderInfo: prefix + mypage + '/trnorder/getOrderInfo', // 求人情報取得
  getOrdersInfo: prefix + mypage + '/trnorder/getOrdersInfo',
  getOrderDetail: prefix + mypage + '/trnorder/get_order_detail',
  getOrdersDetail: prefix + mypage + '/trnorder/get_orders_detail',
  getJobSearchPublicList: prefix + mypage + '/trnorder/jobsearch', // 公開求人一覧取得
  getPrefName: prefix + mypage + '/mstpref/get_pref_name', // 都道府県取得
  getCityName: prefix + mypage + '/mstcity/getCityName', // 市区町村取得
  getCity: prefix + mypage + '/mstcity',
  // 公開求人
  getAnnualIncome: prefix + mypage + '/mstanualslry', // 年収
  getOvertimeHours: prefix + mypage + '/mstovertime', // 残業時間（月間）
  getRemoteWork: prefix + mypage + '/mstremotework_order', // リモートワークの有無
  getSideJob: prefix + mypage + '/mstsidebusiness_order', // 副業の可否
  getWorkCnd: prefix + mypage + '/mstfeatures', // 企業の特性
  getJobDsc: prefix + mypage + '/mstfeatures_order', // こだわり
  getDialogOccupation: prefix + mypage + '/mstocup3class/getdialog', // 職種
  getOccupation3: prefix + mypage + '/mstocup3class',
  getDialogPref: prefix + mypage + '/mstpref/getdialog', // 勤務地
  getPref: prefix + mypage + '/mstpref', 
  getWalkBus: prefix + mypage + '/mstwalkbus',
  getStation: prefix + mypage + '/mststation', // Get-All
  getDialogIndustry: prefix + mypage + '/mstindsctg/getdialog', // 業種
  getIndsctgName: prefix + mypage + '/mstindsctg/get_indsctg_name',
  getIndustry: prefix + mypage + '/mstindsctg', 
  getEntrance: prefix + mypage + '/mstentrance', 
  getGrad: prefix + mypage + '/mstgrad', 
  getLstschl: prefix + mypage + '/mstlstschl', 
  getYearCategory: prefix + mypage + '/mstyearcategory', // 業種
  addLikeMypage: prefix + mypage + '/trnlike_mypage/add',
  bulkRemoveLikeMypage: prefix + mypage + '/trnlike_mypage/bulkRemove',
  // 保存した条件
  getListSerchMypage: prefix + mypage + '/trnserchmypage/getlistserchmypage',
  getSingleSerchMypage: prefix + mypage + '/trnserchmypage/getsingleserchmypage/{serchId}',
  deleteSerchMypage: prefix + mypage + '/trnserchmypage/isdeletedserchmypage/{serchId}',
  addSerchMypage: prefix + mypage + '/trnserchmypage/add',
  getMaxId: prefix + mypage + '/trnserchmypage/maxid',
  getSchName: prefix + mypage + '/mstschl/get_schlid_name',
  getEmpType: prefix + mypage + '/mstemptype',
  getTrnClient: prefix + mypage + '/trnclient',
  getTrnClientMt: prefix + mypage + '/trnclient_mt',
  getMarketName: prefix + mypage + '/mstmarket/get_marketname_name',
  getOverTimeName: prefix + mypage + '/mstovertime/get_overtime_name',
  getRemoteWorkName: prefix + mypage + '/mstremotework_order/get_remotework_name',
  getSideBusinessName: prefix + mypage + '/mstsidebusiness_order/get_sidebusiness_name',
  getPasiveSmokingName: prefix + mypage + '/mstpassivesmoking/get_passive_smoking_name',
  getCategPasiveSmokingMeasureName: prefix + mypage + '/mstpassivesmokingmeasure/get_categ_passive_smoking_measure_name',
  getResultAmountName: prefix + mypage + '/mstresultamount/get_resultamount_name',
  getRailwayNameByStation: prefix + mypage + '/mstrailwaystation/getRailwayNameByStation',
  getStationName: prefix + mypage + '/mststation/getStationName',
  getWalkbusName: prefix + mypage + '/mstwalkbus/getWalkbusName',
  getWorkType: prefix + mypage + '/mstworktype',
  getApply: prefix + mypage + '/mstapply', // 応募経路マスタ取得
  getFailure: prefix + mypage + '/mstfailure',
  getChangeaddr: prefix + mypage + '/mstchangeaddr',
  getEmployee: prefix + mypage + '/mstemployee',
  getJobchangetime: prefix + mypage + '/mstjobchangetime',
  getSelectionPhase: prefix + mypage + '/mstselectionphase',
  getAspiration: prefix + mypage + '/mstaspiration',
  getCourse: prefix + mypage + '/mstcourse',
  getPurpoSeagent: prefix + mypage + '/mstpurposeagent',
  getOtrlang: prefix + mypage + '/mstotrlang',
  getLanguageLevel: prefix + mypage + '/mstlanguagelevel',
  getLicenses: prefix + mypage + '/mstlicenses',
  getInhabitType: prefix + mypage + '/mstinhabittype',
  getSex: prefix + mypage + '/mstsex',
  getWorkStatus: prefix + mypage + '/mstwkstatus',
  getRailwayStation: prefix + mypage + '/mstrailwaystation',
  getAllowance: prefix + mypage + '/mstallowance',
  getSchl: prefix + mypage + '/mstschl',
  getPeopleManagement: prefix + mypage + '/mstpeoplecategory',
  getPeopleManagementYear: prefix + mypage + '/mstmanagementyearcategory',
  getListed: prefix + mypage + '/mstlisted',
  // Email Security
  getMailSecuirity: prefix + '/trncareerauthstate/getInfo',
  postMailSecuirityUpdateKey: prefix + '/trncareerauthstate/updateKey',
  postResendMailSecuirity: prefix + '/trncareerauthstate/resend',
  postMailSecurityVerify: prefix + '/trncareerauthstate/verifyKey',
  postMailSecurityCheckKey: prefix + '/trncareerauthstate/checkKey',
  postMailSecurityVerifyWithPassword: prefix + '/trncareerauthstate/verifyKeyWithPassword',
  getEmailAuthInfoByUniqueKey: prefix + '/trncareerauthstate/getInfoByUniqueKey',
  postLastloginUpdate: prefix + '/trnmypage/updateLastLogin',
  postMailSecurityVerifyCp2: prefixCp2 + '/trncareerauthstate/verifyKey',
};
